import { render, staticRenderFns } from "./Guiyue.vue?vue&type=template&id=551d1a5c&scoped=true&"
import script from "./Guiyue.vue?vue&type=script&lang=js&"
export * from "./Guiyue.vue?vue&type=script&lang=js&"
import style0 from "./Guiyue.vue?vue&type=style&index=0&id=551d1a5c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "551d1a5c",
  null
  
)

export default component.exports